import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalFooter,
  ButtonPrimary,
  ButtonPrimaryDark,
} from '@americanexpress/dls-react';

const QuitModal = ({ modalDetails, languageData }) => {
  const {
    redirectToLandingPage,
    title,
    content,
    setShow,
    handleActionsOnExit = null,
  } = modalDetails;

  const {
    continueButtonText,
    exitButtonText,
    modalTitle,
    modalBody,
  } = languageData;

  return (
    <Modal
      id="navbar-quit-modal"
      aria-labelledby="modal-header"
      aria-describedby="modal-body"
      theme={{
        // allows the modal to be scrollable but scrollbar not to be shown
        '& > div': {
          marginTop: '4rem',
          maxWidth: '28rem',
          minWidth: '20.43rem',
          overflowY: 'auto',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '::-webkit-scrollbar': { display: 'none' },
        },
      }}
      reactlytics={{ disable: true }}
    >
      <ModalFooter
        theme={{
          padding: '1.25rem 2.2rem !important',
          // overwrite the default footer alignment
          '& > div': {
            textAlign: 'center',
          },
        }}
      >
        <div className="row">
          <div className="flex flex-column col-md-12 margin-0-lr">
            <div className="margin-2-tb pad-0 margin-0">
              <h2 className="heading-2 margin-1-b" id="modal-header">
                {title || modalTitle}
              </h2>
              {content || modalBody}
            </div>

            <div className="margin-1-tb pad-0 margin-0">
              {continueButtonText && (
                <div className="margin-1-b">
                  <ButtonPrimary
                    reactlytics={{ element: 'ExitButton', detail: 'Continue' }}
                    onClick={() => setShow(false)}
                  >
                    {continueButtonText}
                  </ButtonPrimary>
                </div>
              )}
              <div className="margin-1-tb pad-0 margin-0">
                {exitButtonText && (
                  <div className="margin-1-b save-exit">
                    <ButtonPrimaryDark
                      reactlytics={{ element: 'ExitButton', detail: 'Leave' }}
                      onClick={() => {
                        sessionStorage.setItem('isExitBtnClicked', true);
                        if (handleActionsOnExit) {
                          handleActionsOnExit();
                        }
                        redirectToLandingPage();
                        setShow(false);
                      }}
                    >
                      {exitButtonText}
                    </ButtonPrimaryDark>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};

QuitModal.propTypes = {
  modalDetails: PropTypes.objectOf(PropTypes.string),
  languageData: PropTypes.objectOf(PropTypes.string),
};

export default QuitModal;
